import React from 'react'

import { Field } from 'formik'

import { TiposDocumentoSerieConstant } from 'constants/index'

import { Form } from '_zari/core'

const SerieCell = ({ cellInfo, checked }) => {
  return (
    <Field name='_idsSeries'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          id={`check-${cellInfo._id}`}
          label={`${cellInfo.serie} - (${TiposDocumentoSerieConstant.__dictionary[cellInfo.tipoSerie].nombre})`}
          value={cellInfo._id}
          checked={checked}
        />
      )}
    </Field>
  )
}

export default React.memo(SerieCell)
